import { FormInput } from 'components';
import { ButtonWithLoading } from 'components/custom/button/ButtonWithLoad';
import { FC, useEffect, useState } from 'react';
import { Modal, Button, Col, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { SortApiService } from '../service/SortApiService';
import { success } from 'utils/notification';

type CreateSortContainerProps = {
    toggleModal: () => void;
    resetTable: () => void;
};

interface ContainerSortFormInputs {
    numberOfContainers: string;
    licensePlate: string;
    // metadata: string;
}

const initialFormData: ContainerSortFormInputs = {
    numberOfContainers: "",
    licensePlate: ""
}

export const CreateSortContainer: FC<CreateSortContainerProps> = ({ toggleModal, resetTable }) => {
    const [loading, setLoading] = useState(false);
    const sortApiService = SortApiService();

    const {
        handleSubmit,
        register,
        formState: { errors },
        setValue,
        watch,
        reset,
        getValues,
    } = useForm<ContainerSortFormInputs>({ defaultValues: initialFormData });

    const onSubmitSearch = (props: any) => {
        setLoading(true);
        sortApiService.addContainer({
            ...props,
            numberOfContainers: props.numberOfContainers,
            licensePlate: props.licensePlate
        })
            .then(() => {
                success('Sort container created successfully!');
                resetTable();
                toggleModal();
            })
            .finally(() => {
                setLoading(false);
            });
    }

    // Inside your component...
    useEffect(() => {
        setValue('numberOfContainers', '1');
    }, [setValue]);

    return (
        <Modal show={true} onHide={toggleModal} size="lg" centered>
            <Modal.Header onHide={toggleModal} closeButton>
                <h4>Create a new sort container</h4>
            </Modal.Header>
            <Modal.Body>
                <form id="containerSortCreateForm" onSubmit={handleSubmit(onSubmitSearch)}>
                    <Row>
                        <Col xs={12}>
                            <FormInput
                                name="numberOfContainers"
                                type="select"
                                options={Array.from({ length: 100 }, (_, i) => i + 1).map((i) => ({
                                    value: i.toString(),
                                    label: i.toString(),
                                }))}
                                label="Number of containers"
                                register={register}
                                validation={{
                                    required: true
                                }}
                                errors={errors}
                                setValue={setValue}
                                selectValue={watch('numberOfContainers')}
                                selectStyle={{
                                    maxMenuHeight: 200
                                }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormInput
                                name="licensePlate"
                                type="text"
                                value={watch('licensePlate')}
                                register={register}
                                setValue={setValue}
                                label="License plate:"
                            />
                        </Col>
                    </Row>
                </form>
            </Modal.Body>
            <Modal.Footer>
                <Row className='justify-content-end'>
                    <Col md="auto">
                        <Button variant='light' onClick={toggleModal} className='fw-bold'>Close</Button>
                    </Col>

                    <Col md="auto">
                        <ButtonWithLoading
                            label='Save'
                            isLoading={loading}
                            variant='primary'
                            type='submit'
                            form='containerSortCreateForm'
                            className='fw-bold'
                        />
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
};
